import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import SnGrid from "@shared/components/Grid/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import { showPopupModal } from "@widgets/CommonModal";
import SysPwdPopup from "@widgets/commonpopup/SysPwdPopup";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_MTL_BAS_REG_004 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridref1 = useRef<any>(null);
  const searchRef = useRef<any>(null);
  const { userInfo } = global();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any[]>([]);
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [dataSource1, setDataSource1] = useState<any>();
  const SharedFormref1 = useRef<any>();
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [gridFocus, setGridFocus] = useState(false);
  //#endregion

  //#region panel 사이즈 관련
  const cd_menu = Menuprops.cd_menu || "SN_MTL_BAS_REG_004";
  const defaultSize = {
    panel1width: "49.5%",
    panel2width: "49.5%",
  };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize); // SnResizable들의 크기
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    gridref1.current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));
  //#endregion

  //#region OnSearch
  const onSearch = async () => {
    const modifiedRowsH = gridref1.current.getChange();
    if (modifiedRowsH.modifiedRowcount > 0) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) {
          return;
        }
      } else if (confirm === undefined) {
        return;
      }
    }
    try {
      const params = {
        id: "sn_mtl_bas_reg_004_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);
      if (data[0] && data[0].length > 0) {
        // 1. 그리드 데이터가 바인딩되었음을 기다림
        await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

        // 2. 첫 번째 행 선택 및 포커스 설정
        gridref1.current.selectAndFocusRow(0);
        setGridFocus(true);
      }

      gridref1.current.resetUpdate();
    } catch (error: any) {}
  };
  //#endregion

  //#region onInsert
  const onInsert = async () => {
    try {
      const newRow = {};
      gridref1.current?.addRow(newRow);
      setTimeout(() => {
        gridref1.current.api.setFocusedCell(
          gridref1.current.api.getDisplayedRowCount() - 1,
          "cd_module"
        );
      }, 50);
    } catch (error: any) {}
  };
  //#endregion

  //#region onBeforeaddRow
  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      //const masIotypeChanges = gridref1.current.getChange().insert;

      //if (masCcChanges.length <= 0) return false;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        yn_use: "Y",
        yn_prm: "N",
        fg_map: "1",
      };
      Object.assign(newRow, updatedRow); // 원본 객체 수정

      return true;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  //#region onDelete
  const onDelete = () => {
    try {
      gridref1.current?.deleteSelectedRows();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#endregion

  //#region onSave
  const onSave = async () => {
    try {
      gridref1.current.api.stopEditing();
      const requiredValuesCheckL = gridref1.current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return;
      }
      const changesRow = gridref1.current.getChange();
      const Inserts = changesRow.insert ?? [];
      for (let row of Inserts) {
        if (row.cd_io && row.cd_io.length > 6) {
          await showDialog("alter", "수불형태가 6자리를 초과하였습니다.");
          return;
        }
      }
      const SaveData = {
        mas_iotype: changesRow,
      };
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      await fnSave("SN_MTL_BAS_REG_004_SAVE_01", SaveData);

      gridref1.current.resetUpdate();

      return true;
    } catch (error: any) {}
  };
  //#endregion

  //#region onGrid1BtnsClick
  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnReset") {
      const modifiedRows = gridref1.current.getChange();
      if (modifiedRows && modifiedRows.modifiedRowcount > 0) {
        await showDialog(
          "alter",
          "수정중인 건을 저장 후 진행해주시기 바랍니다."
        );
        return;
      }

      const confirm = await showDialog(
        "confirm",
        "추가 작성한 내용이 모두 삭제됩니다. \r\n초기설정으로 전체 초기화 하시겠습니까?"
      );
      if (!confirm) {
        return;
      }

      const component = <SysPwdPopup />;
      const result = await showPopupModal({
        title: "SYS계정 암호를 입력해주세요.",
        children: component,
        width: "390px",
        height: "210px",
        checkData: false,
      });
      if (!result || result === "close") return;

      const params = { cd_firm: userInfo.cd_firm };
      const reset = await callApi("SN_MTL_BAS_REG_004_btnReset", params);
      if (reset.status) {
        onSearch();
      }
    }

    if (id === "btnApply") {
      try {
        const modifiedRows = gridref1.current.getChange();
        if (modifiedRows.modifiedRowcount > 0) {
          await showDialog(
            "alter",
            "수정중인 건을 저장 후 진행해주시기 바랍니다."
          );
          return;
        }
        const confirm = await showDialog(
          "confirm",
          "추가사항을 적용 하시겠습니까?"
        );
        if (!confirm) return;

        const params = { cd_firm: userInfo.cd_firm };
        const result = await callApi("SN_MTL_BAS_REG_004_btnApply", params);
        if (result.status) {
          onSearch();
        }
      } catch (error: any) {}
    }
  };
  //#endregion

  //#region onFocusedRowChanged
  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData(focusedRowData);
    },
    [focusedRowData]
  );
  //#endregion

  //#region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          
        ></SearchPanel>
      </div>
      <div className="flex h-full w-full min-w-0 space-x-1.5 overflow-y-hidden">
        <SnResizable
          direction={"width"}
          seq={1}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel1width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        >
          <SnGrid
            ref={gridref1}
            seq={1}
            
            enableAddRow={true}
            columnConfig={columns} // 컬럼 설정 전달
            rowData={dataSource1}
            onFocusedRowChanged={onFocusedRowChanged}
            rowSelection="single"
            isEditable={true}
            onBeforeAddRow={onBeforeAddRowH}
            title="수불정보"
            resizeController={{
              defaultSize: defaultSize,
              onResizeStop: onResizeStop,
            }}
          />
        </SnResizable>
        <SnResizable
          direction={"width"}
          seq={2}
          cd_menu={cd_menu}
          defaultSize={defaultSize}
          size={sizes.panel2width}
          onResizeStop={onResizeStop}
          enable={{ right: true }}
          minWidth={130}
        >
          <SharedForm
            ref={SharedFormref1}
            data={focusedRowData}
            controls={sharedForm}
            gridref={gridref1}
            
            title="상세정보"
            header={
              <div>
                <SnButton
                  text={"전체초기화"}
                  onClick={() => {
                    onGrid1BtnsClick("btnReset");
                  }}
                />
                <SnButton
                  text={"추가사항적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApply");
                  }}
                />
              </div>
            }
          ></SharedForm>
        </SnResizable>
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_BAS_REG_004;
